/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The unique ID of the blockchain. For a list of supported chains see the [FAQ](https://uniswap-docs.readme.io/reference/faqs).
 */
export enum ChainId {
    '_1' = 1,
    '_10' = 10,
    '_56' = 56,
    '_130' = 130,
    '_137' = 137,
    '_324' = 324,
    '_480' = 480,
    '_1868' = 1868,
    '_8453' = 8453,
    '_10143' = 10143,
    '_42161' = 42161,
    '_42220' = 42220,
    '_43114' = 43114,
    '_81457' = 81457,
    '_7777777' = 7777777,
    '_1301' = 1301,
    '_84532' = 84532,
    '_11155111' = 11155111,
}
